import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BookingServiceBase, BsFreeSlotsRequestDto, TimeSlotDto } from '@shared/booking-feature';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SelfBookingServiceClientService extends BookingServiceBase {
    getFreeSlots(bsId: number, allowanceToken: string, data: BsFreeSlotsRequestDto): Observable<TimeSlotDto[]>;
    getFreeSlots(maskedBsId: string, maskedContractorId: string, data: BsFreeSlotsRequestDto): Observable<TimeSlotDto[]>;
    getFreeSlots(
        bsIdOrMaskedBsId: number | string,
        allowanceTokenOrMaskedContractorId: string,
        data: BsFreeSlotsRequestDto,
    ): Observable<TimeSlotDto[]> {
        let params = new HttpParams();
        params = data.serviceUuid ? params.append('service', data.serviceUuid) : params;
        params = data.subcontractorUuid ? params.append('subcontractor', data.subcontractorUuid) : params;
        params = data.orgUnitUuids ? params.append('orgid', data.orgUnitUuids) : params;
        params = data.from ? params.append('from', data.from) : params;
        params = data.to ? params.append('to', data.to) : params;
        params = data.numSlots ? params.append('nSlots', data.numSlots.toString()) : params;

        return this.get(`${this.PatientApiBaseUrl}/freeslots/bs/${bsIdOrMaskedBsId}/contractors/${allowanceTokenOrMaskedContractorId}`, { params });
    }
}
